import { RedirectToProgressionPage } from '../actions/redirectToProgressionPage'

const redirectToProgressionPage = (
  state = true,
  action: RedirectToProgressionPage
) => {
  switch (action.type) {
    case 'DX/REDIRECT_TO_PROGRESSION_PAGE':
      return action.payload
    default:
      return state
  }
}

export default redirectToProgressionPage
